import { Map as ImmutableMap } from 'immutable';
import { useMemo } from 'react';
import I18n from 'I18n';

// @ts-expect-error untyped import
import FilterOperatorDisplay from 'customer-data-filters/components/operator/FilterOperatorDisplay';
// @ts-expect-error untyped import
import ConnectReferenceResolvers from 'reference-resolvers/ConnectReferenceResolvers';
// @ts-expect-error untyped import
import ResolveReferences from 'reference-resolvers/ResolveReferences';
// @ts-expect-error untyped import

import { listMembershipFromObjectSegFilterStrict, getReferencedObjectTypeListMembership, getInboundDbListType } from '../../list-membership-utils';
import { useSnowflakeJoinMetadata } from '../../../../metadata/joins-with-meta';
import { getIsUngated, useFilterRelevantUserInfo } from '../../../../../shared/lib/utils';
// @ts-expect-error untyped import
import { useTableDescription, useTableSource } from '../SourceMeta';
import { getTableLabelWithSelfJoins } from '../../../../utils/table-utils';
import { getObjectTypeFamily, buildSpecialOptionsByReferenceType
// @ts-expect-error untyped import
} from '../../xo-filter-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getMappedProps = (filter, source, list, resolvers) => {
  const {
    filter: listFilter
  } = filter;
  const {
    objectTypeId
  } = source;
  const filterFamily = getObjectTypeFamily(objectTypeId);
  const getFamilyValueResolver = () => resolvers[getInboundDbListType(filterFamily)];
  const operator = listFilter && listFilter.get('operator') ? listMembershipFromObjectSegFilterStrict(listFilter.toJS()) : undefined;
  const listText = I18n.text('reporting-snowflake.filter-editor.list-membership.field-name');
  return {
    currencyCode: 'USD',
    isReadOnly: true,
    isXoEnabled: true,
    operator,
    getSpecialOptionsForReferenceType: buildSpecialOptionsByReferenceType(undefined, undefined),
    fieldDefinitions: ImmutableMap(),
    getLabelString: () => list ? list.label : listText,
    getReferencedObjectType: getReferencedObjectTypeListMembership,
    getFamilyValueResolver
  };
};
const ListOperatorDisplayView = ({
  filter,
  source,
  resolvers,
  list
}) => {
  const {
    userGates
  } = useFilterRelevantUserInfo();
  const filterOperatorDisplayProps = useMemo(() => getMappedProps(filter, source, list, resolvers), [filter, source, list, resolvers]);
  return filterOperatorDisplayProps.operator ? /*#__PURE__*/_jsx(FilterOperatorDisplay, Object.assign({}, filterOperatorDisplayProps, {
    getIsUngated: gate => getIsUngated(gate, userGates)
  })) : /*#__PURE__*/_jsx("span", {
    children: /*#__PURE__*/_jsx("strong", {
      children: filterOperatorDisplayProps.getLabelString()
    })
  });
};
const mapResolversToProps = (resolvers, {
  filter,
  source
}) => {
  const listId = filter.getIn(['filter', 'listId']);
  const filterFamily = getObjectTypeFamily(source.objectTypeId);
  if (!listId) {
    return {};
  }
  return {
    list: resolvers[getInboundDbListType(filterFamily)].byId(listId)
  };
};
const ListOperatorDisplay = ResolveReferences(mapResolversToProps)(ListOperatorDisplayView);
const ListFilterLabel = ({
  filter,
  resolvers
}) => {
  const {
    field: {
      table
    }
  } = filter;
  const source = useTableSource(table);
  const tableDescription = useTableDescription();
  const {
    data: allJoinMetadata
  } = useSnowflakeJoinMetadata();
  const tableName = getTableLabelWithSelfJoins(table || '', tableDescription, source, allJoinMetadata);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("span", {
      style: {
        display: 'block',
        fontWeight: 600,
        marginBottom: -4
      },
      children: tableName
    }), /*#__PURE__*/_jsx(ListOperatorDisplay, {
      filter: filter,
      source: source,
      resolvers: resolvers
    })]
  });
};
export default ConnectReferenceResolvers(resolvers => ({
  resolvers
}))(ListFilterLabel);